import { render, staticRenderFns } from "./trade_card.vue?vue&type=template&id=78e8ee8c&scoped=true&"
import script from "./trade_card.vue?vue&type=script&lang=js&"
export * from "./trade_card.vue?vue&type=script&lang=js&"
import style0 from "./trade_card.vue?vue&type=style&index=0&id=78e8ee8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e8ee8c",
  null
  
)

export default component.exports